/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit None/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import BooleanInput from './BooleanInput/index'
import DateInput from './DateInput/index'
import No from './No/index'
import NumberInput from './NumberInput/index'
import React from 'react'
import StringInput from './StringInput/index'



/** @type {import('Simple/types.js').View} */
export default function None({
  children,
  viewPath = "/DesignSystem/AppsLauncherProperties/Content/ActiveStep/None"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedTypeValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BooleanInput'}>
<BooleanInput
  viewPath={`${viewPath}/BooleanInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DateInput'}>
<DateInput
  viewPath={`${viewPath}/DateInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NumberInput'}>
<NumberInput
  viewPath={`${viewPath}/NumberInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'StringInput'}>
<StringInput
  viewPath={`${viewPath}/StringInput`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}